export default {
    MobileWidth : 768,
  }
  